import footer from './footer';
import header from './header';
import headerMenu from './headerMenu';

export default {
	footer,
	header,
	headerMenu
};
